import { render, staticRenderFns } from "./official_extension.vue?vue&type=template&id=5178a644&scoped=true"
import script from "./official_extension.vue?vue&type=script&lang=js"
export * from "./official_extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178a644",
  null
  
)

export default component.exports